import * as React from 'react'
import { TerminalScoreContext } from './TerminalScoreProvider';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

type Props = {
  className?: string,
  status: 'stable'|'unstable'|'scored'|undefined,
}

const TerminalNodeStatus: React.FC<Props> = ({ status, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  return (
    <div className={' ' + className}>
      <div className="inline-block">
      {status === 'stable' &&
        <div className="bg-yellow-600 bg-opacity-40 rounded-lg  pl-1 pr-2 py-1 flex justify-center items-center">
          <FiberManualRecordIcon className="inline pr-1 text-yellow-500" />
          Stable
        </div>
      }

      {status === 'scored' &&
        <div className="text-white bg-green-800 rounded-lg pl-1 pr-2 py-1 flex justify-center items-center">
          <FiberManualRecordIcon className="inline pr-1" style={{color: 'rgb(70, 232, 14)'}} />
          Good
        </div>
      }

      {status === 'unstable' &&
        <div className="text-white bg-red-500 bg-opacity-40 rounded-lg pl-1 pr-2 py-1 flex justify-center items-center">
          <FiberManualRecordIcon className="inline pr-1 text-red-500 "/>
          Unstable
        </div>
      }

      {status === undefined &&
        <div className="text-white bg-green-700 rounded-lg px-2 py-1 flex justify-center items-center">
          <FiberManualRecordIcon className="inline pr-1" style={{color: 'rgb(70, 232, 14)'}} />
          Not included
        </div>
      }
      </div>
    </div>
  );
}

export default TerminalNodeStatus;

